import { useEffect, useMemo, useState } from 'react';
import * as turf from '@turf/turf';
import { CsoMarkerAndPopover } from '@/components/markers/CsoMarkerContent';
import { useMapContext } from '@/contexts/MapContext';
import { useMapFilterContext } from '@/contexts/MapFilterContext';
import { fetchCsoData } from '@/libs/cso-data-fetch';
import { markerConfig } from '../markerconfig';

export function CsoMarkers({ zIndex }: { zIndex: string }) {
  const { map, mapFilterPolygon } = useMapContext();
  const { showCsoMarkers } = useMapFilterContext();
  const [csoData, setCsoData] = useState<any>(null);

  useEffect(() => {
    async function getData() {
      try {
        const data = await fetchCsoData();
        setCsoData(data);
      } catch (error) {
        console.error('Error fetching CSO data:', error);
      }
    }

    getData();
  }, []);

  const filteredCsos = useMemo(() => {
    if (!map || !csoData || !mapFilterPolygon) {
      return null;
    }
    return (
      <>
        {csoData.features.map(
          (
            feature: {
              type: string;
              geometry: { coordinates: any; type: string };
              properties: {
                id: string;
                objectId: string;
                company: string;
                status: string;
                statusStart: string;
                events: { latest: { startTime: string; endTime: string; durationMinutes: number } };
                receivingWaterCourse: string;
                lastUpdated: string;
              };
            },
            index: React.Key | null | undefined
          ) => {
            const point = [
              parseFloat(feature.geometry.coordinates[0]),
              parseFloat(feature.geometry.coordinates[1]),
            ];

            const isInPolygon = turf.booleanPointInPolygon(point, mapFilterPolygon);

            if (isInPolygon) {
              return (
                <CsoMarkerAndPopover
                  key={index}
                  map={map}
                  feature={feature}
                  config={markerConfig.cso}
                  zIndex={zIndex}
                />
              );
            }

            return null;
          }
        )}
      </>
    );
  }, [csoData, mapFilterPolygon]);

  if (!showCsoMarkers || !filteredCsos) {
    return null;
  }

  return filteredCsos;
}
